import { Card, Statistic } from 'antd'
import { useTranslation } from 'react-i18next'

import { formatKrw } from '@repo/shared'

type Props = {
  amount: number
  isLoading: boolean
}

export function DashboardRevenueCard({ amount, isLoading }: Props): React.JSX.Element {
  const { t } = useTranslation()

  return (
    <Card data-testid="dashboard-revenue-card">
      <Statistic
        title={t('pages.dashboard.annualRevenue')}
        value={amount}
        formatter={() => formatKrw(amount)}
        loading={isLoading}
      />
    </Card>
  )
}
